var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "tracking-panel" }, [
      _c("h1", [_vm._v("Consignment tracking")]),
      _vm._v(" "),
      _c("table", [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.consignmentScans, function (scan, index) {
              return [
                _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(scan.Description))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.formatDate(scan.Scanned)))]),
                  _vm._v(" "),
                  _c("td", { attrs: { rowspan: "1" } }, [
                    _vm._v(_vm._s(scan.ExtraInfo)),
                  ]),
                ]),
              ]
            }),
          ],
          2
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tracking-panel" }, [
      _c("div", [
        _c("h1", [
          _vm._v("Item tracking (" + _vm._s(_vm.items.length) + " items)"),
        ]),
        _vm._v(" "),
        _vm.deliveredCount > 0
          ? _c(
              "div",
              { staticClass: "status-pill" },
              [
                _c("information-circle"),
                _vm._v(
                  " " +
                    _vm._s(_vm.deliveredCount) +
                    " of " +
                    _vm._s(_vm.items.length) +
                    " item" +
                    _vm._s(_vm.items.length === 1 ? "" : "s") +
                    " delivered"
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          { staticStyle: { position: "relative" } },
          [
            _c("search-icon", {
              staticStyle: {
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
                left: "8px",
                "pointer-events": "none",
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.itemSearchText,
                  expression: "itemSearchText",
                },
              ],
              staticStyle: {
                margin: "0",
                width: "447px",
                "padding-left": "32px",
              },
              attrs: {
                name: "itemSearch",
                type: "text",
                placeholder: "Search by tracking number",
              },
              domProps: { value: _vm.itemSearchText },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.itemSearchText = $event.target.value
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { position: "relative" } },
          [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.statusFilter,
                    expression: "statusFilter",
                  },
                ],
                staticStyle: { "padding-right": "32px" },
                attrs: { name: "statusFilter" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.statusFilter = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { attrs: { value: "all" } }, [
                  _vm._v("All items"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "delivered" } }, [
                  _vm._v("Delivered"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "notDelivered" } }, [
                  _vm._v("Not delivered"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("chevron-arrow-down", {
              staticStyle: {
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
                right: "8px",
                "pointer-events": "none",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("table", [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.items, function (item, itemIndex) {
              return [
                _vm.shouldShow(item)
                  ? [
                      _vm.itemScans[item.ItemNo] &&
                      _vm.itemScans[item.ItemNo].length > 0
                        ? _vm._l(
                            _vm.visibleScans(item),
                            function (scan, scanIndex) {
                              return _c(
                                "tr",
                                [
                                  scanIndex === 0
                                    ? [
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              rowspan:
                                                _vm.visibleScans(item).length,
                                            },
                                          },
                                          [_vm._v(_vm._s(item.ItemNo))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            class: {
                                              clickable:
                                                _vm.itemScans[item.ItemNo]
                                                  .length > 1,
                                            },
                                            attrs: {
                                              rowspan:
                                                _vm.visibleScans(item).length,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleItemExpanded(
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.highlight(item.ItemId)
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            attrs: {
                                              rowspan:
                                                _vm.visibleScans(item).length,
                                            },
                                          },
                                          [_vm._v(_vm._s(item.Type))]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.itemScans[item.ItemNo][scanIndex]
                                          .Description
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDate(
                                          _vm.itemScans[item.ItemNo][scanIndex]
                                            .Scanned
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.itemScans[item.ItemNo][scanIndex]
                                          .ExtraInfo
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  scanIndex === 0
                                    ? _c(
                                        "td",
                                        {
                                          attrs: {
                                            rowspan:
                                              _vm.visibleScans(item).length,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleItemExpanded(
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm.isExpanded(item)
                                            ? _c("chevron-arrow-up")
                                            : _c("chevron-arrow-down", {
                                                attrs: {
                                                  disabled:
                                                    _vm.itemScans[item.ItemNo]
                                                      .length <= 1,
                                                },
                                              }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                2
                              )
                            }
                          )
                        : [
                            _c("tr", [
                              _c("td", [_vm._v(_vm._s(item.ItemNo))]),
                              _vm._v(" "),
                              _c("td", [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.highlight(item.ItemId)
                                    ),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(item.Type))]),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c(
                                "td",
                                { attrs: { rowspan: "1" } },
                                [
                                  _c("chevron-arrow-down", {
                                    attrs: { disabled: "" },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                    ]
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("table", { staticClass: "table" }, [
      _c("caption", { staticStyle: { "border-bottom": "none" } }, [
        _vm._v("Tracking"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "431px" } }, [_vm._v("Event")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "253px" } }, [_vm._v("Date & time")]),
        _vm._v(" "),
        _c("th", [_vm._v("Extra info")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "32px" } }, [_vm._v("Item")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "254px" } }, [
          _vm._v("Tracking number"),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "112px" } }, [_vm._v("Packaging")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "254px" } }, [_vm._v("Event")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "182px" } }, [_vm._v("Date & time")]),
        _vm._v(" "),
        _c("th", [_vm._v("Extra info")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "14px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }